<form [formGroup]="form">
  <div class="tab-panel-content-wrapper">

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        New/Used Why Buy Message
        <i class="pi pi-info-circle"
           pTooltip="Enter an account-wide ‘Why Buy’ message that highlights key reasons to choose the dealership. This syncs to the Why Buy section on all non-service pages."
           tooltipPosition="top"></i>
      </label>
      <textarea pInputText rows="6" class="tall-textarea" formControlName="whyBuyMessage"></textarea>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Service Why Buy Message
        <i class="pi pi-info-circle"
           pTooltip="Enter a ‘Why Buy’ message tailored for service pages, highlighting reasons to service at the dealership."
           tooltipPosition="top"></i>
      </label>
      <textarea pInputText rows="6" class="tall-textarea" formControlName="serviceWhyBuyMessage"></textarea>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">Dealer License Name
        <i class="pi pi-info-circle"
           pTooltip="Dealer name exactly as it appears on the California dealer license."
           tooltipPosition="top"></i>
      </label>
      <input pInputText class="input-text-wrapper" type="text" formControlName="dealerLicenseName">
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">ARD Number
        <i class="pi pi-info-circle"
           pTooltip="California DMV ARD # associated with the dealer license."
           tooltipPosition="top"></i>
      </label>
      <input pInputText class="input-text-wrapper" type="text" formControlName="ardNumber">
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">Licensed Service Phone Number
        <i class="pi pi-info-circle"
           pTooltip="Service phone number must ring directly to dealership and be answered by a living being (may not necessarily match the License exactly)."
           tooltipPosition="top"></i>
      </label>
      <input pInputText class="input-text-wrapper" type="text" formControlName="servicePhoneNumber">
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Dealer License Name
        <i class="pi pi-info-circle"
           pTooltip="Dealer name exactly as it appears on the California dealer license."
           tooltipPosition="top"></i>
      </label>
      <input pInputText type="text" formControlName="dealerLicenseName">
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        ARD Number
        <i class="pi pi-info-circle"
           pTooltip="California DMV ARD # associated with the dealer license."
           tooltipPosition="top"></i>
      </label>
      <input pInputText type="text" formControlName="ardNumber">
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Licensed Service Phone Number
        <i class="pi pi-info-circle"
           pTooltip="Service phone number must ring directly to dealership and be answered by a living being (may not necessarily match the License exactly)."
           tooltipPosition="top"></i>
      </label>
      <input pInputText type="text" formControlName="servicePhoneNumber">
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Service Disclosure
        <i class="pi pi-info-circle"
           pTooltip="Text entered here will display at the bottom of all Service Landing Pages. Useful for California requirements or other service compliance messaging."
           tooltipPosition="top"></i>
      </label>
      <textarea pInputText rows="6" class="tall-textarea" formControlName="serviceDisclosure"></textarea>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Page Header Main CTA Text
        <i class="pi pi-info-circle"
           pTooltip="Customize the main button text in the header sections of landing pages. By default, this CTA reads ‘Special Offers’."
           tooltipPosition="top"></i>
      </label>
      <input pInputText class="input-text-wrapper" type="text" formControlName="pagesMainCtaText">
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Inventory Main CTA Text
        <i class="pi pi-info-circle"
           pTooltip="Changes the ‘View Inventory’ button text in page header sections."
           tooltipPosition="top"></i>
      </label>
      <input pInputText class="input-text-wrapper" type="text" formControlName="inventoryMainCtaText">
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        Show Used Ads on New VLPs
        <i class="pi pi-info-circle"
           pTooltip="Show Used Ads on New VLPs"
           tooltipPosition="top"></i>
      </label>
      <p-toggleswitch formControlName="newVlpShowUsed"></p-toggleswitch>
    </div>

    <div class="tab-panel-input-wrapper final-url-dropdown">
      <label class="field-input-label tab-input-label">
        No Offer Set Lead Form
        <i class="pi pi-info-circle"
           pTooltip="When enabled, a lead form will display if no Offer Sets are available. When disabled, nothing will show."
           tooltipPosition="top"></i>
      </label>
      <p-toggleswitch formControlName="showDefaultForm"></p-toggleswitch>
    </div>
  </div>
</form>
